/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { cancelSubscriptionPriceForUserR, deactivateSubscriptionPriceR } from 'actions/SubscriptionPricesActions';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import List from 'components/List';
import _ from 'lodash';
import ClientSubscriptionForLoggedInUserNewAndEdit from 'components/layout/subscriptions/ClientSubscriptionForLoggedInUserNewAndEdit';
import { getTimezoneFromState } from 'helpers/intl';
import Breadcrumb from '../Breadcrumb';
import SimplePrompt from '../SimplePrompt';
import Loader from '../Loader';
import IntlDateTime from '../IntlDateTime';

class SubscriptionsForUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      showEdit: false,
      subscriptionId: '',
      subscription: {},
    };
  }

  openActivateSubscription = subscription => {
    this.setState({ subscription }, () => {
      this.setState({ showNew: true });
    });
  };

  openEditSubscription = subscription => {
    this.setState({ subscription }, () => {
      this.setState({ showEdit: true });
    });
  };

  closeAddSubscription = () => {
    this.setState({ showNew: false });
  };

  closeEditSubscription = () => {
    this.setState({ showEdit: false });
  };

  cancelSubscription = subscriptionId => {
    const { subscriptions, cancelSubscriptionPriceForUserR } = this.props;
    const {
      data: { list },
    } = subscriptions;

    const subscription = list.find(({ id }) => id === subscriptionId);
    if (typeof subscription?.activesubscriptions !== 'undefined' && subscription?.activesubscriptions.length > 0) {
      _.forEach(subscription.activesubscriptions, sub => {
        sub.is_active = false;
        deactivateSubscriptionPriceR(sub?.id, sub ?? null);
      });
    }
  };

  translateSubscription = description => {
    const {
      appIntl: { locale },
    } = this.props;

    const matchingDescription = description.find(({ lang }) => lang === locale);

    return matchingDescription?.description; // or name
  };

  getBreadcrumb = () => {
    const {
      appIntl: { urlPrefix },
      intl: { messages },
    } = this.props;

    const crumbs = [
      { link: urlPrefix + 'account', name: 'Dashboard' },
      { link: urlPrefix + 'account/settings', name: messages.settings },
      { link: null, name: messages.subscriptions_ },
    ];

    return <Breadcrumb crumbs={crumbs} className="p-t-0" />;
  };

  render() {
    const {
      intl: { messages },
      subscriptions,
      clientId,
    } = this.props;
    const { showNew, showEdit, subscription } = this.state;
    const {
      data: { list },
      pending,
    } = subscriptions;

    const columns = [
      messages.subscription_name,
      messages.subscription_description,
      messages.subscription_fee,
      // messages.subscription_startingFee,
      messages.subscription_start,
      messages.subscription_end,
      messages.subscription_billing_period,
      messages.subscription_status,
      messages.subscription_action,
    ];

    const tBody = list.map(subscription => {
      const { id, name, description, fee, starting_fee, activesubscriptions, billing_cycle } = subscription;
      let activeSubFee = fee;
      let activeSubStartFee = starting_fee;
      let activeSubPeriodStart;
      let activeSubPeriodEnd;
      let activeSubMetaData;
      let activeSubIsWebsiteItem;
      let activeSubDesiredDomain;
      let activeSubIsActive = false;
      /* activesubscriptions should basically be limited to 1 */
      if (typeof activesubscriptions !== 'undefined' && activesubscriptions.length > 0) {
        _.forEach(activesubscriptions, sub => {
          activeSubFee = sub?.fee;
          activeSubStartFee = sub?.starting_fee;
          activeSubPeriodStart = sub?.period_start;
          activeSubPeriodEnd = sub?.period_end;
          activeSubIsActive = sub?.is_active;
          activeSubMetaData = sub?.meta_data;
        });
      }

      if (activeSubMetaData) {
        activeSubIsWebsiteItem = activeSubMetaData?.order_item_type === 'itemWebsite';
        activeSubDesiredDomain = activeSubIsWebsiteItem ? activeSubMetaData?.desired_domain ?? '' : '';
      }

      let descriptionColumnValue = this.translateSubscription(description) ?? '';

      return (
        <tr key={id} onClick={() => {}}>
          <td className="v-align-middle">
            <span>{name}</span>
          </td>
          <td className="v-align-middle">
            <span>{descriptionColumnValue}</span>
            {descriptionColumnValue !== '' && activeSubIsWebsiteItem && activeSubDesiredDomain !== '' ? <br /> : <></>}
            {activeSubIsWebsiteItem && activeSubDesiredDomain !== '' ? (
              <span className="p-l-5">{activeSubDesiredDomain}</span>
            ) : (
              <></>
            )}
          </td>
          <td className="v-align-middle">
            <span>{activeSubFee}</span>
          </td>
          {/*<td className="v-align-middle">*/}
          {/*  <span>{activeSubStartFee}</span>*/}
          {/*</td>*/}
          <td className="v-align-middle">
            <span>{activeSubPeriodStart ? <IntlDateTime date={activeSubPeriodStart} /> : <></>}</span>
          </td>
          <td className="v-align-middle">
            <span>{activeSubPeriodEnd ? <IntlDateTime date={activeSubPeriodEnd} /> : <></>}</span>
          </td>
          <td className="v-align-middle">
            {billing_cycle === 'monthly' ? (
              <span>{messages.monthly}</span>
            ) : billing_cycle === 'annual' ? (
              <span>{messages.annual}</span>
            ) : (
              <></>
            )}
          </td>
          <td className="v-align-middle subscriptionStatus">
            <span className="p-r-5">
              {activeSubIsActive ? (
                <i className="fad fa-fw fa-circle fa-2x" style={{ color: 'green' }} />
              ) : (
                <i className="fad fa-fw fa-circle fa-2x" style={{ color: 'red' }} />
              )}
            </span>
          </td>
          <td className="v-align-middle text-right">
            {activeSubIsActive ? (
              <>
                <Button
                  onClick={() => this.openEditSubscription(subscription)}
                  bsStyle="warning"
                  className="pull-right m-l-5 m-t-5 m-b-5"
                  title="extend"
                >
                  <i className="far fa-clock" />
                  <span className="hidden-xs"> {messages.subscription_liu_extend}</span>
                </Button>
                {/*<SimplePrompt
                  showLabel
                  buttonLabel={messages.subscription_liu_cancel}
                  className="m-l-5 m-t-5 m-b-5"
                  onSuccess={() => this.cancelSubscription(id)}
                />*/}
              </>
            ) : (
              <SimplePrompt
                showLabel
                bsStyle="success"
                iconClass="far fa-check"
                buttonLabel={messages.subscription_liu_subscribe}
                className="m-l-5 m-t-5 m-b-5"
                onSuccess={() => this.openActivateSubscription(subscription)}
              />
            )}
          </td>
        </tr>
      );
    });

    const url =
      clientId != null
        ? `/api/subscriptions/list/subscriptions/foruser/${clientId}.json`
        : '/api/subscriptions/list/subscriptions/forloggedinuser.json';

    return (
      <>
        <div className="padding-25 sm-padding-10">
          <List
            listName="subscriptionsForUser"
            url={url}
            // urlData={urlData}
            list={subscriptions}
            title={messages.subscriptions_}
            iconClass="fad fa-repeat-alt"
            // showNew
            newText={messages.add_subscription}
            // newAction={this.openAddSubscription}
            showSearch={false}
            // sortOptions={['relevance,desc', 'cdate,desc', 'mdate,desc', 'priority,desc']}
            // breadcrumb={this.getBreadcrumb()}
            metaIdentifier="Subscriptions:Subscription"
            // displayTypes={['list', 'columns']}
            // activeDisplayType={displayType}
            // changeDisplayType={this.changeDisplayType}
            // filters={filters}
          >
            {pending ? (
              <Loader />
            ) : (
              <Table responsive hover>
                <thead>
                  <tr>
                    {columns.map(column => {
                      return (
                        <th key={column} className={column === messages.actions ? 'text-right' : ''}>
                          {column}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <ReactCSSTransitionGroup
                  transitionName="tablerows"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={1}
                  component="tbody"
                >
                  {tBody}
                </ReactCSSTransitionGroup>
              </Table>
            )}
          </List>
        </div>
        <div id="subscription">
          {showNew && (
            <ClientSubscriptionForLoggedInUserNewAndEdit
              show={showNew}
              close={this.closeAddSubscription}
              subscription={subscription}
              form="new"
              pending={pending}
            />
          )}
          {showEdit && (
            <ClientSubscriptionForLoggedInUserNewAndEdit
              show={showEdit}
              close={this.closeEditSubscription}
              subscription={subscription}
              form="edit"
              pending={pending}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    subscriptions: state.list.subscriptionsForUser,
    defaultTimezone: getTimezoneFromState(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    cancelSubscriptionPriceForUserR: (id, data) => {
      dispatch(cancelSubscriptionPriceForUserR(id, data));
    },
  };
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(SubscriptionsForUser)));
